import { RequirementSections } from "./requirement-sections.component";
import { RequirementSection } from "./requirement-section.component";
import { EditRequirementSection } from "./requirement-section.edit.component";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from "@uirouter/angular";
import { requirementSectionsState, requirementSectionState, newRequirementSectionState, editRequirementSectionState } from "./requirement-sections.states";
import { AllMaterialModule } from "../../all-material.components";
import { MatDatepickerModule } from "@angular/material";
import { FlexLayoutModule } from "@angular/flex-layout";

import SharedModule from "../../shared/shared.module";
import { CoreModule } from "../../core/core.module";

let REQUIREMENT_SECTION_STATES = [requirementSectionsState, requirementSectionState, newRequirementSectionState, editRequirementSectionState];

import { ConfirmDialog } from "../../shared/confirm-dialog.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AllMaterialModule,
        MatDatepickerModule,
        SharedModule,
        CoreModule,
        FlexLayoutModule,
        UIRouterModule.forChild({ states: REQUIREMENT_SECTION_STATES })
    ],
    declarations: [RequirementSections, RequirementSection, EditRequirementSection],
    entryComponents: [ConfirmDialog]
})
export class RequirementSectionsModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/requirementsections/requirement-sections.module.ts